import { useQuery } from '@tanstack/react-query';
import Queries from '../Common/Queries';
import { getHomeFreshProducts } from '../Pages/Services/homeService';

export default function useGetHomeProducts() {
    return useQuery({
        queryKey: [Queries.GET_HOME_FRESH_PRODUCTS],
        queryFn: () => getHomeFreshProducts(),
        select: (data) => data.data || [],
        meta: { errorMessage: 'Failed to fetch home page products' },
    });
}
